import React from "react";
import { OverlayTrigger, Tooltip, Popover } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";

const FieldHelpTooltip = ({ text, title, variant = "tooltip", placement = "top" }) => {
  if (variant === "popover") {
    return (
      <OverlayTrigger
        trigger={["hover", "click"]}
        placement={placement}
        rootClose
        overlay={
          <Popover>
            {title && (
              <Popover.Header
                style={{
                  background: "#fdf2f5",
                  borderBottom: "1px solid #f9c8d6",
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#C9194A",
                }}
              >
                {title}
              </Popover.Header>
            )}
            <Popover.Body
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: "12px",
                color: "#444",
                lineHeight: 1.5,
                maxWidth: "260px",
              }}
            >
              {text}
            </Popover.Body>
          </Popover>
        }
      >
        <span style={{ marginLeft: "5px", cursor: "pointer", display: "inline-flex", alignItems: "center" }}>
          <AiOutlineInfoCircle size={14} color="#C9194A" />
        </span>
      </OverlayTrigger>
    );
  }

  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip style={{ fontFamily: "'Poppins', sans-serif", fontSize: "12px" }}>
          {text}
        </Tooltip>
      }
    >
      <span style={{ marginLeft: "5px", cursor: "pointer", display: "inline-flex", alignItems: "center" }}>
        <AiOutlineInfoCircle size={14} color="#6c757d" />
      </span>
    </OverlayTrigger>
  );
};

export default FieldHelpTooltip;
